import { toast } from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/packages/frontend/ui/src/toast/toast.ts";
import { useQueryClient } from "@tanstack/react-query";
import { useRouter } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/node_modules/.pnpm/react-i18next@17.1.8_i18next@26.5.10_typescript@6.0.3__react-dom@18.3.1_react@18.3.1__react@18.3.1_typescript@6.0.3/node_modules/react-i18next/dist/es/useTranslation.js";

import { UNAUTHENTICATED_EVENT } from "../api/client";
import { subscribeAuth } from "./broadcast";
import { meQuery } from "./me";

const AUTH_PATHS = /^\/(app\/login|app\/register|portal\/login|auth\/)/;

/**
 * Mounted once by the root route:
 * - FE-01 FR-FE01-20: a 401 clears `me`, toasts once and sends the area to its login with
 *   `redirect` (public pages never redirect). Concurrent 401s produce one redirect.
 * - FE-01 §8: login/logout in another tab re-runs the guards here.
 */
export function useAuthSync() {
  const router = useRouter();
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  useEffect(() => {
    let handling = false;
    const onUnauthenticated = () => {
      if (handling) return;
      const { pathname, searchStr } = router.state.location;
      if (AUTH_PATHS.test(pathname)) return;
      const area = pathname.startsWith("/portal")
        ? "owner"
        : pathname.startsWith("/app")
          ? "seller"
          : null;
      if (!area) return;
      handling = true;
      queryClient.setQueryData(meQuery.queryKey, null);
      toast(t("session.expired"), { key: "session-expired" });
      void router
        .navigate({
          to: area === "owner" ? "/portal/login" : "/app/login",
          search: { redirect: `${pathname}${searchStr}`, notice: "expired" },
          replace: true,
        })
        .finally(() => {
          setTimeout(() => {
            handling = false;
          }, 2000);
        });
    };
    window.addEventListener(UNAUTHENTICATED_EVENT, onUnauthenticated);
    const unsubscribe = subscribeAuth((message) => {
      if (message.type === "logout") queryClient.clear();
      else queryClient.removeQueries({ queryKey: meQuery.queryKey });
      void router.invalidate();
    });
    return () => {
      window.removeEventListener(UNAUTHENTICATED_EVENT, onUnauthenticated);
      unsubscribe();
    };
  }, [router, queryClient, t]);
}
